import { Component, OnInit } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'app-task-status3',
    template: '<div class="empty-status" [innerHtml]="htmlCode"></div>',
    styleUrls: ['./task-status3.component.scss'],
    standalone: false ,  // NOSONAR
})
export class TaskStatus3Component implements OnInit {
public htmlCode: any;
agInit(_params: ICellRendererParams): void{
   //  do something 
}
  constructor() { }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}

}
